module.exports = __webpack_public_path__ + "static/logo-ghd-e508d413a6f054762557185e89367284.png";